import { render, staticRenderFns } from "./VCurrencyField.vue?vue&type=template&id=0f0d171e"
import script from "./VCurrencyField.js?vue&type=script&lang=js&external"
export * from "./VCurrencyField.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports